import React, {useState} from 'react';

export default function useDialogState(initialState = {}) {
    const [dialogState, setDialogState] = useState(initialState);

    function openDialog(dialog, callback = () => {}) {
        return event => {
            event && event.preventDefault();

            setDialogState(prevState => {
                return {
                    ...prevState,
                    [dialog]: true
                };
            });

            callback();
        };
    }

    function closeDialog(dialog, callback = () => {}) {
        return event => {
            event && event.preventDefault();

            setDialogState(prevState => {
                return {
                    ...prevState,
                    [dialog]: false
                };
            });

            callback();
        };
    }

    return {
        dialogState,
        openDialog,
        closeDialog
    };
}